import React, { useEffect, useState } from "react"
import { v4 as uuid } from "uuid"
import { sort } from "fast-sort"
import Send from "../../core/communication"
import GPTModalScreen from "../../screen/GPTModalScreen"
import { customToast } from "../../components/Toast"

const GPTModal = ({
  title,
  onSaveActions,
  actions,
  showModalActions,
  handleCloseActionsModal,
  hiddenAddingButton,
  actionList = [],
  projects = [],
  values,
  handleChangeProject,
}) => {
  const [modalActionValues, setValues] = useState({ actions: [] })
  const [loading, setLoading] = useState(false)
  const [saving, setSaving] = useState()
  const [open, setOpen] = useState(false)
  const [newRow, setNewRow] = useState()
  const [copyRows, setCopyRows] = useState([])
  const [selectedRows, setSelectedRows] = useState([])

  useEffect(() => {
    if(actionList && actionList.length) {
      setValues({
        actions: actionList
      })
    }
  }, [actionList])

  const getDuplicateActions = (title = "", area = "", level = "") => {
    return (
      actions.filter((row) => row?.title === title && row?.area === area && row?.level === level) ||
      []
    )
  }

  const onSave = async () => {
    setSaving(true)
    try {
      let newValues = modalActionValues?.actions.filter(
        (row) => selectedRows.filter((item) => item === row?.id)[0],
      )

      newValues = newValues.map((item) => ({ ...item, title: item?.title || item?.action }))

      await onSaveActions((newValues && newValues) || [], setOpen)
      setValues({ actions: []})
    } catch (e) {
      console.log({ e })
    }

    //setOpen(false), setShowModalActions(false)
    setSaving(false)
  }

  const onSearch = async () => {
    try {

      if (!values.description) {
        alert("Adicione uma busca!")
        return
      }
  
      setLoading(true)
  
      const data = await Send.post("/ia/recommend-action", {
        text: values.description,
      })
  
      const transformData = data?.result.map((item) => ({
        ...item,
        id: uuid(),
        title: item?.action,
        edit: true,
        new: false,
      }))
  
      const arr1 = [...transformData, ...copyRows]
  
      setValues((values) => ({ ...values, actions: sort(arr1).asc((u) => u?.title) }))
      setLoading(false)
    } catch(error) {
      customToast('Não foi possível gerar ações, tente novamente.', 'warning');
      setValues((values) => ({ ...values, actions: [] }))
      setLoading(false);
    }
    
  }

  useEffect(() => {
    if (actions && actions.length) {
      let newValues = Array.from(values?.actions || [])
      console.log(newValues)
      newValues = newValues.filter(
        ({ title, area, level }) => !getDuplicateActions(title, area, level).length,
      )
      setValues({ actions: sort(newValues).asc((u) => u?.title) })
    }
  }, [actions])

  useEffect(() => {
    if (newRow) {
      setValues((values) => ({
        ...values,
        actions: [{ ...newRow, new: false }, ...values.actions],
      }))
      setNewRow(null)
    }
  }, [newRow])

  useEffect(() => {
    if (copyRows.length > 0) {
      const temp = modalActionValues.actions.filter((obj1) => !copyRows.some((obj2) => obj1.id === obj2.id))
      const arr1 = [...temp, ...copyRows]
      setValues({ actions: sort(arr1).asc((u) => u?.title) })
    }
  }, [copyRows])

  const onSelectedRowsChange = (dataId) => {
    setSelectedRows(dataId)
  }

/*   useEffect(() => {
    if(showModalActions){
      setOpen(true)
      setValues({ actions: [] })
    }
    else {
      setOpen(false)
      setValues({ actions: [] })
    }
  }, [showModalActions]) */


  return (
    <GPTModalScreen
      {...{
        onSearch,
        loading,
        onSave,
        title,
        open,
        setOpen,
        saving,
        values: modalActionValues,
        projectValues: values?.projects,
        setValues,
        setNewRow,
        newRow,
        setCopyRows,
        copyRows,
        onSelectedRowsChange,
        selectedRows,
        showModalActions,
        handleCloseActionsModal,
        hiddenAddingButton,
        projects,
        handleChangeProject
      }}
    />
  )
}

export default GPTModal
